import React, { useState, useMemo, useRef } from "react";
import PropTypes from "prop-types";
import { IconButton, Typography } from "@material-ui/core";
import { CheckCircle } from "@material-ui/icons";
import { PasswordFieldStyles } from "./passwordField.style";
import CustomTooltip from "../customTooltip/customTooltip";
import { WithStyleInput } from "./withStyleInput";
import { VisualizeIcon, VisualizeOffIcon } from "../../shared/icons";

const PasswordField = ({ label, errors, isValid, classes, ...props }) => {
  const [show, setShow] = useState(false);
  const ref = useRef(null);
  const passwordClasses = PasswordFieldStyles();
  const handleToggleShow = () => setShow((current) => !current);

  const adorments = useMemo(
    () => (
      <div className={passwordClasses.inputIcons}>
        <IconButton
          onClick={handleToggleShow}
          edge="end"
          aria-label="Toggle password visibility"
        >
          {show ? <VisualizeIcon /> : <VisualizeOffIcon />}
        </IconButton>
        {isValid ? <CheckCircle className={passwordClasses.checkIcon} /> : null}
      </div>
    ),
    [isValid, show]
  );

  const tooltipMemo = useMemo(() => {
    const errorsMessages = errors || [];

    return errorsMessages.length && errorsMessages instanceof Array ? (
      <CustomTooltip>
        <b>Password Must Include:</b>
        <ul className={passwordClasses.list}>
          {errorsMessages.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>
      </CustomTooltip>
    ) : null;
  }, [errors?.length]);

  return (
    <>
      <Typography className={classes.title}>{label}</Typography>
      <div className={classes.inputContainer}>
        <WithStyleInput
          ref={ref}
          margin="normal"
          variant="outlined"
          autoComplete="off"
          className={classes.input}
          {...props}
          type={show ? "text" : "password"}
        />
        {adorments}
        {tooltipMemo}
      </div>
    </>
  );
};

PasswordField.propTypes = {
  label: PropTypes.string.isRequired,
  isValid: PropTypes.bool.isRequired,
  errors: PropTypes.arrayOf(String),
  classes: PropTypes.object.isRequired,
};

PasswordField.defaultProps = {
  errors: [""],
};

export default PasswordField;
